import { render, staticRenderFns } from "./cancelOrder.vue?vue&type=template&id=10049d00&scoped=true"
import script from "./cancelOrder.vue?vue&type=script&lang=js"
export * from "./cancelOrder.vue?vue&type=script&lang=js"
import style0 from "./cancelOrder.vue?vue&type=style&index=0&id=10049d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10049d00",
  null
  
)

export default component.exports